import React from 'react'
import PropTypes from 'prop-types'
import PatientRow from './Row'
import css from './styles.css'

const PAGE_SIZE = 50

let patientRow

const List = ({ patients, isTops, formatPhoneNumber, totalPatients }) => (
  <ul className={css.list}>
    {
      patients.map((patient, ind) => {
        patientRow = (
          <li className={css.row} key={patient.id}>
            <PatientRow
              isTops={isTops}
              key={patient.id}
              formatPhoneNumber={formatPhoneNumber}
              {...patient}
            />
          </li>
        )

        return ind % PAGE_SIZE === 0 && ind > 0
          ? [patientRow, <span key="num">{ind + 1} of {totalPatients}</span>]
          : patientRow
      })
    }
  </ul>
)

List.propTypes = {
  isTops: PropTypes.bool.isRequired,
  patients: PropTypes.arrayOf(PropTypes.object).isRequired,
  formatPhoneNumber: PropTypes.func.isRequired,
  totalPatients: PropTypes.number.isRequired,
}

export default List



// WEBPACK FOOTER //
// ./src/components/PatientGroups/PatientList/List.js